import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { IMAGES, BLOG_POSTS } from '../data/content';

const thumbs = {
  'best-ayurveda-doctor-bhopal': 'https://ik.imagekit.io/gnzsnmo3fr/vaidyam/blogs/drmonikablog.webp',
  'panchakarma-guide-bhopal':    'https://ik.imagekit.io/gnzsnmo3fr/vaidyam/blogs/panchkarmablog.jpg',
  'ayurvedic-weight-loss-bhopal':'https://ik.imagekit.io/gnzsnmo3fr/vaidyam/blogs/weightlossblog.jpg',
  'dosha-vata-pitta-kapha':      'https://ik.imagekit.io/gnzsnmo3fr/vaidyam/blogs/doshablog.webp',
  'shirodhara-benefits-bhopal':  'https://ik.imagekit.io/gnzsnmo3fr/vaidyam/blogs/sirodharablog.jpg',
  'swarna-prashan-bhopal':       'https://ik.imagekit.io/gnzsnmo3fr/vaidyam/blogs/sarnaprshanblog.png',
};

export default function Blog() {
  return (
    <div style={{ background:'#1E1108', paddingTop:'70px', minHeight:'100vh' }}>
      <Helmet>
        <title>Ayurveda Blog | Best Ayurveda Doctor near me</title>
        <meta name="description" content="Ayurveda health guides, treatment articles, and wellness tips by Dr. Monika Jain — Panchakarma, Kerala therapies, and natural healing in Bhopal." />
      </Helmet>
      <div style={{ position:'relative', height:'300px', overflow:'hidden' }}>
        <img src="https://ik.imagekit.io/gnzsnmo3fr/vaidyam/hero/blogshero.webp" alt="" style={{ width:'100%', height:'100%', objectFit:'cover', filter:'brightness(0.28)' }}/>
        <div style={{ position:'absolute', inset:0, background:'linear-gradient(to top,#1E1108,transparent 60%)' }}/>
        <div style={{ position:'absolute', inset:0, display:'flex', alignItems:'flex-end', padding:'0 48px 48px' }}>
          <div style={{ maxWidth:'1280px', margin:'0 auto', width:'100%' }}>
            <span style={{ fontSize:'10px', letterSpacing:'3px', color:'#C8941A', textTransform:'uppercase', fontWeight:500, display:'block', marginBottom:'12px' }}>Ayurveda Journal</span>
            <h1 style={{ fontFamily:'Cormorant Garamond, serif', fontSize:'56px', color:'#F0E6D8', lineHeight:1.05, marginBottom:'10px' }}>Blog & Articles</h1>
            <p style={{ fontSize:'15px', color:'rgba(240,230,216,0.45)', maxWidth:'480px', lineHeight:1.8 }}>Expert Ayurvedic health guides from Dr. Monika Jain's 25+ years of experience.</p>
          </div>
        </div>
      </div>
      <div style={{ padding:'60px 48px 100px' }}>
        <div style={{ maxWidth:'1280px', margin:'0 auto', display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:'2px' }}>
          {BLOG_POSTS.map(post => (
            <Link to={`/blog/${post.id}`} key={post.id} style={{ display:'block', textDecoration:'none', background:'#1E0E05', overflow:'hidden', transition:'background 0.25s' }}
              onMouseEnter={e=>e.currentTarget.style.background='#251205'}
              onMouseLeave={e=>e.currentTarget.style.background='#1E0E05'}
            >
              <div style={{ height:'200px', overflow:'hidden', position:'relative' }}>
                <img src={thumbs[post.id] || IMAGES.mukhabhyang} alt={post.title}
                  style={{ width:'100%', height:'100%', objectFit:'cover', filter:'none', transition:'transform 0.6s ease' }}
                  onMouseEnter={e=>e.target.style.transform='scale(1.05)'} onMouseLeave={e=>e.target.style.transform='scale(1)'}
                />
                <div style={{ position:'absolute', inset:0, background:'linear-gradient(to top, rgba(18,8,2,0.6), transparent 60%)' }} />
              </div>
              <div style={{ padding:'24px 22px' }}>
                <div style={{ display:'flex', gap:'10px', alignItems:'center', marginBottom:'12px', flexWrap:'wrap' }}>
                  <span style={{ fontSize:'9px', letterSpacing:'1.5px', color:'#C8941A', textTransform:'uppercase' }}>{post.category}</span>
                  <span style={{ fontSize:'11px', color:'rgba(240,230,216,0.25)' }}>·</span>
                  <span style={{ fontSize:'11px', color:'rgba(240,230,216,0.25)' }}>{post.readTime}</span>
                  <span style={{ fontSize:'11px', color:'rgba(240,230,216,0.25)' }}>·</span>
                  <span style={{ fontSize:'11px', color:'rgba(240,230,216,0.25)' }}>{post.date}</span>
                </div>
                <h2 style={{ fontFamily:'Cormorant Garamond, serif', fontSize:'20px', color:'#F0E6D8', lineHeight:1.4, marginBottom:'12px' }}>{post.title}</h2>
                <p style={{ fontSize:'13px', color:'rgba(240,230,216,0.4)', lineHeight:1.7, marginBottom:'16px' }}>{post.excerpt.slice(0, 110)}...</p>
                <span style={{ fontSize:'11px', color:'rgba(200,148,26,0.6)', letterSpacing:'0.5px' }}>Read Article →</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
